export const TIMEZONE_REGION = {
  LABEL: 'Region',
  REQUIRED: 'Required',
  ERROR: 'Region is required.',
  SHORT_ERROR: 'Required',
  //   DESCRIPTION: "Select your region.",
  PLACEHOLDER: 'Select your region',
  REGIONS: ['North America', 'EMEA', 'Asia Pac.'],
};

export const LEGACY_WHATSAPP_TEMPLATE_MESSAGE =
  'This template was created before integration of WhatsApp templates. This template cannot be found in the templates section within accounts.';
